// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bvCXb","expireSoon":"styles_expireSoon__Gxyzd"};